import {useHistory} from "react-router-dom";
import {AuthContext} from '../context/AuthContext.js'
import {GeneralesContext} from '../context/GeneralesContext.js'
import SearchIcon from '@material-ui/icons/Search';
import {makeStyles} from '@material-ui/core/styles';
import { Box, Card, CardContent, FormControl, FormControlLabel,
    Grid, IconButton, InputLabel, Radio, RadioGroup, Select as MaterialSelect,
    TextField, Tooltip, Typography, LinearProgress } from '@material-ui/core'
import TablaMarca from './TablaMarca.jsx';
 
import moment from 'moment';
import axios from 'axios';
import qs from 'qs';
import {ErrorGeneral, llamadaApiToken, llamaApiCargaToken} from '../funciones/ClienteAxios.jsx';
import React, {useContext, useEffect, useState} from "react";
import ModNvoEditMaquina from './NvoEditMarca.jsx'
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import ReplayIcon from '@material-ui/icons/Replay';
import TablaModelo from "./TablaModelo.jsx";
const useStyles = makeStyles((theme) => ({
    title2: {
        fontSize: 18,
    },
    subTitle2: {
        fontSize: 12,
    },
    altura2: {
        minHeight: 70,
        marginTop: 0,
        paddingTop: 0,
    },
    altura3: {
        minHeight: 145,
        marginTop: 0,
        paddingTop: 0,
    },

}));


const CatalogoMarca = () => {
    let history = useHistory();
    const classes = useStyles();
    const idusu = localStorage.getItem('UsuId');
    const source = axios.CancelToken.source();
 
    const {usuario, guardarUsuario} = useContext(AuthContext);
    const {guardarGenerales} = useContext(GeneralesContext);
    const [listBit, setListBit] = useState([])
    const [ordenBusq, setOrdenBusq] = useState({orden: '', turno: ''});
    const [fechasSeleccionadas, setFechasSeleccionadas] = useState({inicio: new Date(), final: new Date()});
    const {orden, turno} = ordenBusq;
    const [estatus, setEstatus] = useState(-2);
    const [buscar, setBuscar] = useState(true);
    const [terminal, setTerminal] = useState([]);    
    const [listMarca, setListMarca] = useState([])
    const [listModelo, setListModelo] = useState([])
    const [listModeloFiltro, setListModeloFiltro] = useState([])
    const [buscar2, setBuscar2] = useState([])
    const [modalAbierto, setModalAbierto] = useState(false);    
    const [modalNvo, setModalNvo] = useState(false);
    const [espera, setEspera] = useState(false);
    const[filtro,setFiltro] = useState({supervisa:false})
    const[filtroSerie,setFiltroSerie] = useState("")
    const[filtroNoEco,setFiltroNoEco] = useState("")
    const[filtroDescr,setFiltroDescr] = useState("")
    const{supervisa}=filtro

    useEffect(() => {                       

        const veriSesion = () => {
            const usu = localStorage.getItem('UsuarioNom');
            const nvl = localStorage.getItem('Tipo');
            if (usu === null) {
                guardarUsuario([])
                guardarGenerales([])
                localStorage.clear();
                history.push("/")
            } else {
                if (usuario.length === 0) {
                    guardarUsuario({Nombre: usu, nivel: nvl});
                }

                guardarGenerales({Titulo: 'Catálogo Marca'})
                               
            }
        }
        veriSesion();
        return () => {
            source.cancel();
        }
    }, []);

    useEffect(()=>{
        getListMarca()         
    },[buscar])
 
    useEffect(()=>{        
        getListModelo()
    },[buscar2])

    const getListMarca = () => {
        const data = qs.stringify({
            Usuario: idusu,
            ip: "127.0.0.0",
            idDispositivo: '89y7gttvjhj98h'
        });
        const url = "/maquinaria/marca";

        function respuestaListTermin(aux) {
            if (aux[0].Id !== -1) {                
                setListMarca(aux)
            }
        }

        llamaApiCargaToken(data, url, respuestaListTermin, ErrorGeneral, setEspera, history, source)
    };    

    const getListModelo = () => {
        const data = qs.stringify({
            Usuario: idusu,
            ip: "127.0.0.0",
            idDispositivo: '89y7gttvjhj98h'
        });
        const url = "/maquinaria/marca/modelo";

        function respuestaListTermin(aux) {
            if (aux[0].Id !== -1) {                
                setListModelo(aux)
            }
        }

        llamaApiCargaToken(data, url, respuestaListTermin, ErrorGeneral, setEspera, history, source)
    };    

    const onChange = e => {
        let expNopermitida = new RegExp('[#._:$!%-({})/*=?|]');
        let expMenos = new RegExp('-');
        let expMas = new RegExp('[+]');
        let expCadena = new RegExp('[A-Za-z0-9]');
        if ((expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) &&
            !expMenos.test(e.target.value) && !expMas.test(e.target.value)) || e.target.value === ' ' || e.target.value === '') {
            setFiltroNoEco( e.target.value.trim()
            )
        }

    };

    const onChange3 = e => {
        let expNopermitida = new RegExp('[#._:$!%-({})/*=?|]');
        let expMenos = new RegExp('-');
        let expMas = new RegExp('[+]');
        let expCadena = new RegExp('[A-Za-z0-9]');
        if ((expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) &&
            !expMenos.test(e.target.value) && !expMas.test(e.target.value)) || e.target.value === ' ' || e.target.value === '') {
            
            setFiltroDescr( e.target.value.trim())
            
        }

    };
    const funcionActualizar = e => {
        setBuscar(!buscar)
    };

    const funcionActuliza = () => {
        setBuscar(!buscar)
    }

    function handleAbrir() {
        setModalNvo(true)
    }

    const onChangeCheck = (event) => {
        setFiltro({
          ...filtro,
            [event.target.name]: event.target.checked 
          });
    };

    
    const principal = () => {
        return (
        <>
        <Grid container alignItems={'flex-start'} style={{marginTop: '.5rem', marginBottom: '.5rem'}}>
            <Grid item xs={12}>
                <Card className={classes.altura2}>
                    <CardContent style={{padding: '.5rem'}}>
                        <Box   display="flex" alignItems={'center'} flexDirection={"row"} >
                            
                            <Box  >
                                <Tooltip title="Actualizar">
                                <IconButton color="primary" size={"small"} onClick={funcionActuliza}
                                    style={{paddingTop: '.6rem'}}>
                                    <ReplayIcon/>
                                </IconButton>
                                </Tooltip>
                            </Box>                     
                           <Box  >
                                <Tooltip title="Nueva Marca">
                               <IconButton size={"small"} color="primary" onClick={() => handleAbrir()}
                                    style={{paddingTop: '.6rem'}}>
                                    <AddCircleOutlineIcon/>
                                </IconButton>
                                </Tooltip>
                            </Box>    
                            {listMarca.length !==0 ? 
                                <TextField id="outlined-basic" label="Filtrar por Descripción" variant="outlined" size="small"                            
                                    name="filtroDescr" value={filtroDescr} onChange={onChange3}/>
                            :null}
                                   
                            {/* <Grid item>
                                <TextField id="outlined-basic" label="Folio" variant="outlined" size="small"
                                    name="orden" value={orden} onChange={onChange}/>
                            </Grid> */}
                    </Box>
                </CardContent>
            </Card>
            </Grid>
        </Grid>

        <Grid container  alignItems={'flex-start'} >
            <Grid item xs={6}>
                {espera ? 
                    (<Box mt={5} ml={2}><LinearProgress/> </Box>) 
                :   <TablaMarca                         
                        listMarca={listMarca} filtroSerie={filtroSerie}
                        filtroNoEco={filtroNoEco} filtroDescr={filtroDescr}
                        funcionActualizar={funcionActualizar} listModelo={listModelo}
                        setListModeloFiltro={setListModeloFiltro}
                    />
                }
            </Grid>
            
            {listModeloFiltro.length !== 0 ? 
            <Grid item xs={5} style={{marginLeft:"1rem"}}>    
               <TablaModelo                         
                    filtroSerie={filtroSerie}
                    filtroNoEco={filtroNoEco} filtroDescr={filtroDescr}
                    funcionActualizar={()=>setBuscar2(!buscar2)} listModeloFiltro={listModeloFiltro}                    
                />
                </Grid>
            : null
            }
        
        </Grid>
        </>
        )
    }

    const modNvo = modalNvo ? <ModNvoEditMaquina  modalAbierto={modalNvo} setModalAbierto={setModalNvo} 
        titulo={`Nueva Ubicación`} regis={[]} funcionActuliza={funcionActuliza} /> :null
    return (
    <>
        {modNvo}
        {principal()}
        
    </>
    )
}

export default CatalogoMarca